import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * App entry: marketing home is disabled — send everyone to inventory
 * (auth layout redirects unauthenticated users to /login).
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/inventory" })
  },
})
